import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');

const ListOperation = () => import('@/modules/comex/pages/ListOperation/index.vue');
const EditOperation = () => import('@/modules/comex/pages/EditOperation/index.vue');
const LegalizeOperation = () => import('@/modules/comex/pages/LegalizeOperation/index.vue');
const ReportsDownloadView = () => import('@/modules/comex/pages/ReportsDownload/index.vue');

export const comexRoutes: Array<RouteRecordRaw> = [
  {
    path: '/comex',
    component: MainLayout,
    meta: {
      accessRol: {
        section: 'COMEX',
        actions: ['VIEW'],
      },
    },
    children: [
      {
        path: '',
        redirect: { name: 'comex-operations' },
      },
      {
        path: '/comex/operations',
        children: [
          {
            path: '',
            name: 'comex-operations',
            component: ListOperation,
          },
          {
            path: 'edit',
            name: 'comex-operations-edit',
            component: EditOperation,
            meta: {
              hideNabar: true,
              accessRol: {
                section: 'COMEX',
                actions: ['EDIT'],
              },
            },
          },
          {
            path: 'legalize',
            name: 'comex-operations-legalize',
            component: LegalizeOperation,
            meta: { hideNabar: true },
          },
        ],
      },
      {
        path: '/comex/reports',
        children: [
          {
            path: '',
            name: 'comex-reports',
            component: ReportsDownloadView,
          },
        ],
      },
    ],
  },
];

